var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "progress",
    },
    [
      _vm.stepProgress.mailNo
        ? _c("div", { staticClass: "step-title" }, [
            _vm._v(
              _vm._s(_vm.stepProgress.expTextName) +
                _vm._s(_vm.stepProgress.mailNo)
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "step-list",
        },
        [
          _vm.stepProgress.records && _vm.stepProgress.records.length > 0
            ? [
                _c(
                  "ul",
                  _vm._l(_vm.stepProgress.records, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        class: [
                          {
                            fontBold:
                              item.resultFlag === 1 ||
                              item.resultFlag === 3 ||
                              item.pass === "finish",
                          },
                        ],
                      },
                      [
                        _vm.type === "shenheStep"
                          ? _c(
                              "div",
                              {
                                staticClass: "step-time",
                                attrs: { alt: item.title, title: item.title },
                              },
                              [_vm._v(_vm._s(item.title) + " ")]
                            )
                          : _c("div", { staticClass: "step-time" }, [
                              _c("p", [_vm._v(_vm._s(item.changeTime))]),
                              _c(
                                "p",
                                { staticStyle: { overflow: "inherit" } },
                                [_vm._v(_vm._s(item.year))]
                              ),
                            ]),
                        _vm.type === "shenheStep"
                          ? _c(
                              "div",
                              {
                                class: [
                                  { "success-pass": item.pass },
                                  { "danger-spot": item.resultFlag === 3 },
                                  "step-content",
                                ],
                              },
                              [
                                _c("div", { staticClass: "reviewer" }, [
                                  item.pass === "finish"
                                    ? _c("span", [_vm._v("审核完成")])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            index === 0
                                              ? "提交审核人"
                                              : "审核人"
                                          ) +
                                            "：" +
                                            _vm._s(item.userName)
                                        ),
                                      ]),
                                  item.pass === "finish"
                                    ? _c("b")
                                    : item.resultFlag === 0
                                    ? _c("span", { staticClass: "info" }, [
                                        _vm._v("未开始"),
                                      ])
                                    : item.resultFlag === 1
                                    ? _c("span", { staticClass: "info" }, [
                                        _vm._v("进行中"),
                                      ])
                                    : item.resultFlag === 2
                                    ? _c("span", { staticClass: "success" }, [
                                        _vm._v("已通过"),
                                      ])
                                    : item.resultFlag === 3
                                    ? _c("span", { staticClass: "danger" }, [
                                        _vm._v("驳回"),
                                      ])
                                    : item.resultFlag === 4
                                    ? _c("span", { staticClass: "fail" }, [
                                        _vm._v("取消/关闭"),
                                      ])
                                    : item.resultFlag === 5
                                    ? _c("span", { staticClass: "info" }, [
                                        _vm._v("跳过"),
                                      ])
                                    : item.resultFlag === -1
                                    ? _c("span", { staticClass: "success" }, [
                                        _vm._v("已提交"),
                                      ])
                                    : _c("span", {
                                        staticClass: "hide-content",
                                      }),
                                ]),
                                item.resultFlag === 3
                                  ? _c("div", [
                                      _vm._v(
                                        "驳回原因：" +
                                          _vm._s(
                                            item.reason ? item.reason : "无"
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                                item.pass
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          index === 0 ? "提交时间" : "审核时间"
                                        ) +
                                          "：" +
                                          _vm._s(item.createdTime)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          : _c("div", { staticClass: "step-content" }, [
                              _c("p", [_vm._v(_vm._s(item.context))]),
                            ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : [
                _c("h5", [
                  _vm._v(
                    _vm._s(
                      _vm.stepProgress.msg ||
                        _vm.stepProgress.message ||
                        "暂无信息"
                    )
                  ),
                ]),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }